"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = __importDefault(require("../../"));
/**
 * This method retrieves the call limit and utilization data for an application.
 */
class Analytics extends __1.default {
    get basePath() {
        return '/developer/analytics/v1_beta';
    }
    /**
     * This method retrieves the call limit and utilization data for an application.
     *
     * @param apiContext This optional query parameter filters the result to include only the specified API context.
     * @param apiName This optional query parameter filters the result to include only the APIs specified.
     */
    getRateLimits(apiContext, apiName) {
        return this.get(`/rate_limit/`, {
            params: {
                api_context: apiContext,
                api_name: apiName
            }
        });
    }
    /**
     * This method retrieves the call limit and utilization data for an application user.
     *
     * @param apiContext This optional query parameter filters the result to include only the specified API context.
     * @param apiName This optional query parameter filters the result to include only the APIs specified.
     */
    getUserRateLimits(apiContext, apiName) {
        return this.get(`/user_rate_limit/`, {
            params: {
                api_context: apiContext,
                api_name: apiName
            }
        });
    }
}
exports.default = Analytics;
Analytics.id = 'Analytics';
//# sourceMappingURL=index.js.map